export const TESTS_ORDER = {
  given: 'given',
  random: 'random'
};
